import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';


const headerData = [
  { id: 'brand', label: 'MARCA', sort: true },
  { id: 'model', label: 'MODELO', sort: true },
  { id: 'color', label: 'COR', sort: true },
  { id: 'licenseplate', label: 'MATRÍCULA', sort: true },
  { id: 'ordernumber', label: 'Nº ENCOMENDA', sort: true },
  { id: 'orderstatus', label: 'ESTADO DA ENCOMENDA', sort: false },
  { id: 'customer', label: 'CLIENTE', sort: true },
  { id: 'originlocal', label: 'LOCAL ORIGEM', sort: true },
  { id: 'destinationlocal', label: 'LOCAL DESTINO', sort: true },
  { id: 'customerexpecteddeliverydate', label: 'DATA ENTREGA PRETENDIDA PELO CLIENTE', sort: true },
  { id: 'requestdate', label: 'DATA PEDIDO TRANSPORTE', sort: true },
  { id: 'expecteddestinationarrivaldate', label: 'DATA PREVISTA CHEGADA', sort: true },
  { id: 'destinationarrivaldate', label: 'DATA CHEGADA DESTINO', sort: true },
  { id: 'deliverydate', label: 'DATA EFETIVA ENTREGA', sort: true },
  { id: 'expecteddeliverydate', label: 'DATA PREVISTA DE ENTREGA', sort: true },
  { id: 'icon', label: null, sort: false }
];

const styles = theme => ({
  tblHeadT: {
    color: '#ffffff',
    fontSize: '14px'
  },
  tblBorder: {
    border: '2px solid #ffffff'
  },
  headerHeight: {
    height: '40px'
  },
  textCenter: {
    textAlign: 'center'
  },
  cellPadding: {
    paddingLeft: '16px'
  },
  tblSort: {
    height: '12px',
    width: '12px',
    margin: '0px 2px'
  }
});


class RUTransportsWRTTableHeader extends React.Component {

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };


  render() {
    const { order, orderBy, classes } = this.props;

    return (
      <TableRow className={classes.headerHeight} >
        {headerData.map(column => {
          return (
            <TableCell
              key={column.id}
              padding='none'
              sortDirection={orderBy === column.id ? order : false}
              className={classNames(classes.tblHeadT, classes.tblBorder, classes.textCenter, column.sort ? classes.cellPadding : null)}
            >
              {column.sort ?
                <TableSortLabel
                  className={classes.tblHeadT}
                  active={orderBy === column.id}
                  direction={order}
                  onClick={this.createSortHandler(column.id)}
                  classes={{ icon: classes.tblSort }}
                >
                  {column.label}
                </TableSortLabel>
                : column.label}
            </TableCell>
          );
        }, this)}
      </TableRow>
    );
  }
}

RUTransportsWRTTableHeader.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};

export default withStyles(styles)(RUTransportsWRTTableHeader);


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsTransport/UsedRentalsWaitingRequest/RUTransportsWRTTableHeader.js